import { isAddressEqual, parseAbiItem, zeroAddress, } from 'viem';
export const getDecimals = async (client, tokenAddress) => {
    if (isAddressEqual(tokenAddress, zeroAddress)) {
        return 18;
    }
    const data = await client.readContract({
        address: tokenAddress,
        abi: [parseAbiItem('function decimals() view returns (uint8)')],
        functionName: 'decimals',
    });
    return data;
};
//# sourceMappingURL=getDecimals.js.map